import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_40: FaireProductEntity = {
  token: "legacy_prod_abbott-40",
  type: "product",
  name: 'Happiness is... Small Plate 3.5" D',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b31b9c401c3960cce70dbcc3f371c109afd8ca9692fac34bc14907448e6f8110.jpeg",
  priceDollars: 10,
  subcategory: "Tableware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
